export const CATEGORIES = [
  {
    id: 'raw-herbs',
    nameUrdu: 'خالص جڑی بوٹیاں',
    nameEn: 'Raw Herbs',
    taglineUrdu: 'قدرتی، صاف شدہ اور با اثر جڑی بوٹیاں',
    taglineEn: '100% Pure, Handpicked & Potent Raw Herbs',
    icon: 'Leaf',
    bgGradient: 'from-emerald-800 to-emerald-950',
    accentColor: 'text-emerald-400',
    itemCount: '150+ اشیاء',
    showOnHome: true,
    showRowOnHome: true,
    order: 1
  },
  {
    id: 'oils-distillates',
    nameUrdu: 'روغن اور عرقیات',
    nameEn: 'Oils & Distillates',
    taglineUrdu: 'خالص کشیدہ عرقیات اور معیاری نباتاتی تیل',
    taglineEn: 'Pure Distilled Waters & Cold-Pressed Herbal Oils',
    icon: 'Droplets',
    bgGradient: 'from-teal-800 to-teal-950',
    accentColor: 'text-teal-400',
    itemCount: '60+ اشیاء',
    showOnHome: true,
    showRowOnHome: true,
    order: 2
  },
  {
    id: 'majun-jawarish',
    nameUrdu: 'معجون، جوارش اور خمیرہ جات',
    nameEn: 'Majun, Jawarish & Khamira',
    taglineUrdu: 'قانون مفرد اعضاء کے اصولوں پر تیار شدہ مرکبات',
    taglineEn: 'Formulations for Nerves, Heart & Digestion',
    icon: 'Sparkles',
    bgGradient: 'from-amber-900 to-amber-950',
    accentColor: 'text-amber-400',
    itemCount: '80+ اشیاء',
    showOnHome: true,
    showRowOnHome: true,
    order: 3
  },
  {
    id: 'kushta-safoof',
    nameUrdu: 'کشتہ جات اور سفوف',
    nameEn: 'Kushtajat & Powders',
    taglineUrdu: 'طبی اصولوں پر تیار شدہ خالص کشتہ جات و سفوف',
    taglineEn: 'Calx Formulations & Classical Medicated Powders',
    icon: 'ShieldCheck',
    bgGradient: 'from-stone-800 to-stone-950',
    accentColor: 'text-stone-300',
    itemCount: '45+ اشیاء',
    showOnHome: true,
    showRowOnHome: true,
    order: 4
  },
  {
    id: 'syrups-company',
    nameUrdu: 'شربت اور کمپنی پیک پروڈکٹس',
    nameEn: 'Syrups & Branded Products',
    taglineUrdu: 'تازہ اور فرحت بخش شربت و تیار ادویات',
    taglineEn: 'Refreshing Herbal Syrups & Quality Branded Packs',
    icon: 'Package',
    bgGradient: 'from-green-900 to-emerald-950',
    accentColor: 'text-green-400',
    itemCount: '55+ اشیاء',
    showOnHome: true,
    showRowOnHome: true,
    order: 5
  }
];

export const MIZAJ_LIST = [
  { id: 'all', nameUrdu: 'تمام مزاج و تحاریک', nameEn: 'All Profiles' },
  { id: 'asabi-azlati', nameUrdu: 'اعصابی عضلاتی (تر سرد)', nameEn: 'Nervous-Muscular (Moist & Cold)' },
  { id: 'azlati-asabi', nameUrdu: 'عضلاتی اعصابی (خشک سرد)', nameEn: 'Muscular-Nervous (Dry & Cold)' },
  { id: 'azlati-ghaddi', nameUrdu: 'عضلاتی غدی (خشک گرم)', nameEn: 'Muscular-Glandular (Dry & Hot)' },
  { id: 'ghaddi-azlati', nameUrdu: 'غدی عضلاتی (گرم خشک)', nameEn: 'Glandular-Muscular (Hot & Dry)' },
  { id: 'ghaddi-asabi', nameUrdu: 'غدی اعصابی (گرم تر)', nameEn: 'Glandular-Nervous (Hot & Moist)' },
  { id: 'asabi-ghaddi', nameUrdu: 'اعصابی غدی (تر گرم)', nameEn: 'Nervous-Glandular (Moist & Hot)' },
  { id: 'motadil', nameUrdu: 'معتدل المزاج', nameEn: 'Balanced / Temperate' },
];

export const AILMENTS_LIST = [
  { id: 'digestion', nameUrdu: 'معدہ، گیس و ہاضمہ', nameEn: 'Digestion & Stomach' },
  { id: 'joints', nameUrdu: 'جوڑوں و پٹھوں کا درد', nameEn: 'Joints & Muscle Pain' },
  { id: 'respiratory', nameUrdu: 'نزلہ، زکام، کھانسی و گلا', nameEn: 'Cough, Cold & Flu' },
  { id: 'vitality', nameUrdu: 'قوت، توانائی و اعصابی کمزوری', nameEn: 'Vigor, Vitality & Nerves' },
  { id: 'heart-brain', nameUrdu: 'دل، دماغ و یادداشت', nameEn: 'Heart & Brain Health' },
  { id: 'liver-kidney', nameUrdu: 'جگر، گردہ و پیشاب کی جلن', nameEn: 'Liver & Kidney Care' },
  { id: 'skin-hair', nameUrdu: 'جلد کی صفائی و بالوں کی حفاظت', nameEn: 'Skin & Hair Care' },
  { id: 'immunity', nameUrdu: 'قوت مدافعت و خون کی کمی', nameEn: 'Immunity & Blood Health' },
];
